var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout-panoramica" },
    [
      _c("v-main", [
        _c(
          "div",
          { staticClass: "navy layout-panoramica-card" },
          [
            _c("panoramica-status-header"),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "layout-panoramica-body" },
              [
                _c(
                  "transition",
                  {
                    attrs: {
                      name: "layout-panoramica-focus-exit",
                      type: "transition",
                    },
                  },
                  [
                    _vm.panoramicaFocusActive
                      ? _c(
                          "v-btn",
                          {
                            staticClass:
                              "layout-panoramica-focus-exit animation-soft-breathe",
                            attrs: {
                              icon: "",
                              small: "",
                              outlined: "",
                              color: "secondary",
                              title: "Esci dal focus",
                            },
                            on: { click: _vm.toggleAllColumns },
                          },
                          [
                            _c("v-icon", { attrs: { small: "" } }, [
                              _vm._v("fullscreen_exit"),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "transition",
                  { attrs: { name: "layout-panoramica-toolbar" } },
                  [
                    !_vm.panoramicaFocusActive
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "layout-panoramica-side-toolbar navy darken-3",
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass:
                                  "layout-panoramica-side-toolbar-btn",
                                attrs: {
                                  icon: "",
                                  outlined: !_vm.svincolatiCollapsed,
                                  color: _vm.svincolatiCollapsed
                                    ? "primary"
                                    : "primary",
                                  title: "Svincolati",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleColumn(
                                      "svincolatiCollapsed"
                                    )
                                  },
                                },
                              },
                              [
                                _c("v-icon", { attrs: { small: "" } }, [
                                  _vm._v("groups"),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                staticClass:
                                  "layout-panoramica-side-toolbar-btn",
                                attrs: {
                                  icon: "",
                                  outlined: !_vm.planCollapsed,
                                  color: _vm.planCollapsed
                                    ? "primary"
                                    : "primary",
                                  title: "Pianificazione",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleColumn("planCollapsed")
                                  },
                                },
                              },
                              [
                                _c("v-icon", { attrs: { small: "" } }, [
                                  _vm._v("paid"),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-badge",
                              {
                                staticClass:
                                  "layout-panoramica-side-toolbar-badge layout-panoramica-side-toolbar-badge-new",
                                attrs: {
                                  content: "NEW",
                                  color: "error",
                                  "offset-x": "20",
                                  "offset-y": "8",
                                  overlap: "",
                                },
                              },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass:
                                      "layout-panoramica-side-toolbar-btn",
                                    attrs: {
                                      icon: "",
                                      outlined: !_vm.partecipantiCollapsed,
                                      color: _vm.partecipantiCollapsed
                                        ? "primary"
                                        : "primary",
                                      title: "Partecipanti",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleColumn(
                                          "partecipantiCollapsed"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v("people_alt"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-badge",
                              {
                                staticClass:
                                  "layout-panoramica-side-toolbar-badge",
                                attrs: {
                                  value: _vm.showUnreadChatMessagesBadge,
                                  content: _vm.unreadChatMessages,
                                  color: "error",
                                  overlap: "",
                                },
                              },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass:
                                      "layout-panoramica-side-toolbar-btn",
                                    attrs: {
                                      icon: "",
                                      outlined: !_vm.chatCollapsed,
                                      color: _vm.chatCollapsed
                                        ? "primary"
                                        : "primary",
                                      title: "Chat",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleColumn("chatCollapsed")
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v("forum"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "layout-panoramica-side-toolbar-bottom",
                              },
                              [
                                _c("v-divider", {
                                  staticClass:
                                    "layout-panoramica-side-toolbar-divider",
                                }),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass:
                                      "layout-panoramica-side-toolbar-btn",
                                    attrs: {
                                      icon: "",
                                      outlined: _vm.panoramicaFocusActive,
                                      color: _vm.panoramicaFocusActive
                                        ? "secondary"
                                        : "secondary",
                                      title: _vm.toggleAllColumnsTitle,
                                    },
                                    on: { click: _vm.toggleAllColumns },
                                  },
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v(_vm._s(_vm.toggleAllColumnsIcon)),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "layout-panoramica-side-panel layout-panoramica-svincolati-chat navy darken-2",
                    class: {
                      collapsed: _vm.svincolatiCollapsed && _vm.chatCollapsed,
                      "layout-panoramica-svincolati-chat--split":
                        !_vm.svincolatiCollapsed && !_vm.chatCollapsed,
                    },
                  },
                  [
                    !_vm.svincolatiCollapsed
                      ? _c(
                          "section",
                          {
                            staticClass:
                              "layout-panoramica-svincolati-chat-section layout-panoramica-svincolati",
                          },
                          [
                            _c("asta-svincolati", {
                              attrs: { showTitle: "", "small-calciatori": "" },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.chatCollapsed
                      ? _c(
                          "section",
                          {
                            staticClass:
                              "layout-panoramica-svincolati-chat-section layout-panoramica-chat",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "layout-panoramica-chat-content" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "titolo navy--text text--lighten-2 font-hemi-head",
                                  },
                                  [
                                    _vm._v(
                                      "\n                Chat\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "layout-panoramica-chat-messages",
                                  },
                                  [_c("asta-chat-messages")],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "layout-panoramica-chat-input",
                                  },
                                  [_c("asta-chat-input")],
                                  1
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "layout-panoramica-side-panel layout-panoramica-plan navy darken-2",
                    class: { collapsed: _vm.planCollapsed },
                  },
                  [
                    !_vm.planCollapsed
                      ? _c("asta-plan", {
                          staticClass: "layout-panoramica-plan-content",
                          attrs: { showTitle: "", "show-button-rose": false },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("lista-tavolo", {
                  attrs: { collapsed: _vm.partecipantiCollapsed },
                }),
                _vm._v(" "),
                _c("rose-lega", {
                  attrs: {
                    "show-title": "",
                    "squadra-menu-context":
                      _vm.Constants.SQUADRA_TAVOLO_MENU_CONTEXT.PANORAMICA,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }